/**
 * @fileOverview Overlay
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Local:overlay
 * @requires Polyfill:element-prototype-classlist 'Element.classList'
 */

import Overlay from './overlay';

/**
 * @module Search
 */

export default {
  /**
   * Init Search behavior
   * @method Initialization
   */
  initialization() {
    this.btn = document.querySelector( '.ac-menu-search__btn' );
    this.input = document.querySelector( '.ac-menu-search__field' );
    this.form = document.querySelector( '.ac-menu-search__form' );
    this.bridge = document.querySelector( '.ac-bridge' );
    if ( this.btn && this.form && this.input && this.bridge ) {
      this.search = this.btn.parentElement;
      this.btn.addEventListener( 'click', this.onSearchClick.bind( this ));
      this.form.addEventListener( 'submit', this.onSubmit.bind( this ));
    }
  },

  /**
   * Open Search box and open Overlay with transition
   * @method open
   */
  open() {
    Overlay.create();
    this.search.appendChild( Overlay.overlay );
    this.input.value = '';
    Overlay.show();
    this.search.classList.add( 'js-is--open' );
    this.search.classList.add( 'js-is--animated' );
    this.bridge.style.zIndex = '0';
    // set focus
    this.input.focus();

    // On Overlay click close the Search Box
    Overlay.onOverlayClick( this.close.bind( this ));
  },

  /**
   * Close Search box and close Overlay with transition
   * @method close
   */
  close() {
    // Remove Focus
    this.input.blur();

    Overlay.hide();
    this.search.classList.remove( 'js-is--open' );
    this.search.classList.remove( 'js-is--animated' );
    this.bridge.style.zIndex = '';
  },

  /**
   * Click listener
   * @method onSearchClick
   */
  onSearchClick() {
    this.search.classList.contains( 'js-is--open' ) ?
      this.close() : this.open();
  },

  /**
   * Submit listener
   * @method onSubmit
   */
  onSubmit( e ) {
    if ( this.input.value.length === 0 ) {
      e.preventDefault();
      this.search.querySelector( '.form-group__msg' )
        .classList.add( 'js-error-is--displayed' );
    }
  },
}
